import { useMutation } from "react-query";
import { useRouter } from "../../useRouter";
import { useRecoilState } from "recoil";
import { userInfoAtom } from "src/atoms";
import { join as joinReq } from "src/service/sessions";

interface IUseJoinProps {
  onSuccess: () => void;
  onError: () => void;
}
export function useJoin({ onSuccess, onError }: IUseJoinProps) {
  const [userInfo, setUserInfo] = useRecoilState(userInfoAtom);
  const { goConsole } = useRouter();
  const { mutateAsync: mutateJoin } = useMutation("join", joinReq, {
    onSuccess,
    onError,
  });

  return { mutateJoin };
}
